import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { chartColors } from '../../theme';

/**
 * Lista de distribuição: rótulo, valor, percentual e barra de proporção (cor única).
 * items: [{ label, value, adornment? }]
 */
export default function BreakdownList({ title, items = [], formatValue = (v) => v.toLocaleString('pt-BR'), emptyMessage = 'Sem dados.' }) {
    const total = items.reduce((acc, i) => acc + Number(i.value || 0), 0);

    return (
        <Box>
            {title && (
                <Typography variant="overline" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                    {title}
                </Typography>
            )}
            {items.length === 0 ? (
                <Typography variant="body2" color="text.secondary">{emptyMessage}</Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    {items.map((item) => {
                        const pct = total > 0 ? (Number(item.value) / total) * 100 : 0;
                        return (
                            <Box key={item.label}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
                                        {item.adornment || (
                                            <Typography variant="body2" sx={{ color: 'text.primary' }} noWrap>{item.label}</Typography>
                                        )}
                                    </Box>
                                    <Typography variant="body2" sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                                        {formatValue(item.value)}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ width: 40, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
                                        {pct.toFixed(0)}%
                                    </Typography>
                                </Box>
                                <Box sx={{ height: 6, borderRadius: 3, bgcolor: '#F2F4F7', overflow: 'hidden' }}>
                                    <Box sx={{ width: `${pct}%`, height: '100%', bgcolor: chartColors.primary, borderRadius: 3 }} />
                                </Box>
                            </Box>
                        );
                    })}
                </Box>
            )}
        </Box>
    );
}
